import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const RateCardTable = () => {
  const rates = [
    {
      id: 1,
      vehicle: "DZIRE / ETIOS / XCENT",
      local: "Rs.2000/-",
      extraKm: "Rs.12/-",
      extraHr: "Rs.150/-",
      outstation: "Rs.12/-",
      da: "Rs.300/-",
      mumbaiDrop: "Rs.2700/-",
      puneMumbaiReturn: "Rs.4200/-",
    },
    {
      id: 2,
      vehicle: "ERTIGA",
      local: "Rs.2500/-",
      extraKm: "Rs.14/-",
      extraHr: "Rs.200/-",
      outstation: "Rs.14/-",
      da: "Rs.300/-",
      mumbaiDrop: "Rs.3500/-",
      puneMumbaiReturn: "Rs.4900/-",
    },
    {
      id: 3,
      vehicle: "INNOVA",
      local: "Rs.2700/-",
      extraKm: "Rs.17/-",
      extraHr: "Rs.200/-",
      outstation: "Rs.17/-",
      da: "Rs.300/-",
      mumbaiDrop: "Rs.4000/-",
      puneMumbaiReturn: "Rs.6000/-",
    },
    {
      id: 4,
      vehicle: "INNOVA CRYSTA",
      local: "Rs.3300/-",
      extraKm: "Rs.19/-",
      extraHr: "Rs.250/-",
      outstation: "Rs.19/-",
      da: "Rs.300/-",
      mumbaiDrop: "Rs.5000/-",
      puneMumbaiReturn: "Rs.6700/-",
    },
  ];

  return (
    <section className="rate-card-section py-5">
      <div className="container">
        <h2 className="rate-card-title text-center mb-4">
          SAI TRUPTI ENTERPRISES - <span>Rate Card</span>
        </h2>

        <div className="table-responsive">
          <table className="table rate-table text-center align-middle">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Vehicle</th>
                <th>Local 8Hrs/80KM</th>
                <th>Extra KM</th>
                <th>Extra HR</th>
                <th>Outstation (300 KM/day)</th>
                <th>D.A (Outstation)</th>
                <th>Mumbai Drop</th>
                <th>Pune–Mumbai Return</th>
              </tr>
            </thead>
            <tbody>
              {rates.map((rate) => (
                <tr key={rate.id}>
                  <td>{rate.id}</td>
                  <td>{rate.vehicle}</td>
                  <td>{rate.local}</td>
                  <td>{rate.extraKm}</td>
                  <td>{rate.extraHr}</td>
                  <td>{rate.outstation}</td>
                  <td>{rate.da}</td>
                  <td>{rate.mumbaiDrop}</td>
                  <td>{rate.puneMumbaiReturn}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default RateCardTable;
